<template>
    <div>
        <b-form @submit="onSubmit"> 
        <b-row>
            <b-col cols="12" xl="4" class="my-1">  
                <div class="pull-right">
                    <b-button v-if="isFromMessage" v-b-modal.modalReactie variant="themecolor" size="m"><i class="fa fa-comment" aria-hidden="true"></i></b-button>
                </div>     
                <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                    <font-awesome-icon icon="angle-left" size="2x" />
                </b-button>
                <h3 class="text-themecolor my-1">Trigger {{$route.params.triggerId}}</h3>            
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7"  label="Naam" label-for="input-horizontal">
                    <b-form-input ref="vendorname" :key="readCommand.vendorname" id="input-horizontal" v-model="command.vendorname" @onChange='command["vendorname"]=$event'></b-form-input>
                </b-form-group>

                <br/>
                <h3>Gegevens </h3>

                <b-form-group label="KvK" label-for="input-formatter" class="mb-3" >
                    <b-form-input  ref="kvK" :key="readCommand.kvK" id="input-horizontal" v-model="command.kvK" @onChange='command.kvK=$event'></b-form-input>
                </b-form-group>
                <b-form-group label="Btwnummer" label-for="input-formatter" class="mb-3" >
                    <b-form-input ref="vatNumber" :key="readCommand.vatNumber" id="input-horizontal" v-model="command.vatNumber" @onChange='command.vatNumber=$event'></b-form-input>
                </b-form-group>

                <b-form-group label="Iban" label-for="input-formatter" class="mb-3" >
                    <b-form-input ref="iban" :key="readCommand.iban" id="input-horizontal" v-model="command.iban" @onChange='command.iban=$event'></b-form-input>
                </b-form-group>

                <br/>
                <b-button id="btn-save-trigger" size="sm" type="submit"  variant="themecolor" >{{$t('buttons.opslaan')}}</b-button>                      
            </b-col>
        </b-row>
        </b-form>
        <b-modal id="modalReactie" ref="priceagreements" :title="`Melding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form autocomplete="off">
                <b-textarea id="reactie" :value="melding" type="text" />
            </b-form>
        </b-modal>        
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import Command from './command'
import { fabletMixin } from '@/mixins/fabletMixin';

export default {
    name: 'mltriggers-detail',  
    mixins: [fabletMixin],
    data() {
        return {
            readCommand: new Command(),
            command: new Command(),
            isFromMessage: false,
            melding: ''
        }
    },
    computed: {
        ...mapGetters('fmmodule',['mltrigger','mltriggers']),
        ...mapGetters('errors', ['statusCode', 'notFoundError'])
    },
    methods: {
        ...mapActions('fmmodule',['find','create','update','executeCommand','errors']),
        goToHome()
        {
            if (this.isFromMessage) {
                 this.$router.push({ name: `triggermeldingen:index`});
            }
            else {
                this.$router.push({ name: `mltriggers:index`});
            }
        },
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'mltriggers',
                params: vm.command
            };

            vm.update(payload)
            .then(()=> {
                if (vm.isFromMessage) {
                    vm.$router.push({ name: `triggermeldingen:index`, params: { triggerId: -vm.command.triggerId, triggermeldingId: this.$route.params.triggermeldingId }});
                }
                else {
                    vm.$router.push({ name: `mltriggers:index`});
                } 
            });
        } 
    },
    created() {
        var vm = this;
        vm.find({
            resource: 'mltriggers',
            id: this.$route.params.triggerId
        })
        .then(() => {            
            vm.command = new Command(vm.mltrigger)
            vm.readCommand = new Command(vm.mltrigger)
            vm.isFromMessage = this.$route.params.isFromMessage
            vm.melding = this.$route.params.melding
        })
    }
}
</script>
<style>
</style>